module.exports = __webpack_public_path__ + "static/media/logo.1ba097a0.png";